(function ($) {
  DJ.addBehavior('removeMediaConfirm', '.gallery-slider__slider-item', {
    attach: function () {
      const sliderItem = this;
      const removeButton = sliderItem.querySelector('.gallery-slider__remove-button');
      const closePopupButton = sliderItem.querySelector('.gallery-slider__slider-delete-form-close');
      const cancelPopupButton = sliderItem.querySelector('.media-confirm-form [data-drupal-selector="edit-cancel"]');
      const confirmForm = sliderItem.querySelector('.gallery-slider__slider-delete-form');
      const confirmFormShowClass = 'gallery-slider__slider-delete-form--show';
      const popupOverlayStructure = '<div class="popup-overlay"></div>';
      const popupOverlayClass = 'popup-overlay--show';
      const $body = $('body');
      const confirmFormInBody = document.querySelector('.gallery-slider__slider-delete-form--show');

      // Add popup overplay to the body.
      if (!document.querySelector('.popup-overlay')) {
        $body.append(popupOverlayStructure);
      }

      // Remove confirmation popup from the body on function init,
      // because it can stay there after removing the slider item.
      if (confirmFormInBody) {
        $(confirmFormInBody).remove();
      }

      // Hide popup overlay.
      const popupOverlay = document.querySelector('.popup-overlay');
      popupOverlay.classList.remove(popupOverlayClass);

      // Hide popup, overlay and move popup back from the body to the slider item. Unbind keydown.
      const onPopupClose = () => {
        confirmForm.classList.remove(confirmFormShowClass);
        popupOverlay.classList.remove(popupOverlayClass);
        $(sliderItem).append(confirmForm);
        $(document).off('keydown.escRemoveMediaConfirm');
      };

      // Show popup, overlay and move popup from the slider item to the body. Unbind keydown.
      const onPopupOpen = () => {
        $body.append(confirmForm);
        confirmForm.classList.add(confirmFormShowClass);
        popupOverlay.classList.add(popupOverlayClass);
      };

      // Toggle confirmation popup.
      const togglePopup = () => {
        if (!confirmForm) {
          return;
        }

        if (confirmForm.classList.contains(confirmFormShowClass)) {
          onPopupClose();
        } else {
          onPopupOpen();

          $(document).on('keydown.escRemoveMediaConfirm', (e) => {
            if (e.code === 'Escape') {
              onPopupClose();
            }
          });
        }
      };

      // Add event listeners to the buttons.
      if (removeButton) {
        removeButton.addEventListener('click', togglePopup);
      }

      if (closePopupButton) {
        closePopupButton.addEventListener('click', togglePopup);
      }

      if (cancelPopupButton) {
        cancelPopupButton.addEventListener('click', (e) => {
          e.preventDefault();
          togglePopup();
        });
      }
    }
  });
})(jQuery);
